import { __assign } from "tslib";
import * as React from 'react';
import { namespacedClassnames, isPromise } from '../../../../common';
import { Text } from '../../typography';
import { ReactSelectAsync } from '../../../../common/react-select';
import { InlineControl } from '../common';
import { keyCodes, classNames } from '@wix/answers-lib';
import { Icon } from '../../../../primitives/icon/icon';
import { smallCollapsibleToggle } from '../../../../icons';
import { TinyLoader } from '../../../../primitives/loaders/tiny-loader';
import { Tooltip } from '../../../../primitives';
import { isTextSelected } from '../common/utils';
export var deprecatedInlineSingleSelectKey = 'inline-single-select';
var inlineDefaultProps = {
    searchable: true,
    autoFocus: true,
    clearable: false,
    autosize: false,
    onSelectResetsInput: true,
    onBlurResetsInput: true,
    openOnFocus: true,
};
/** @deprecated - use <InlineSingleSelect/> */
export var DeprecatedInlineSingleSelect = function (props) {
    var value = props.value, onChange = props.onChange, texts = props.texts, className = props.className, options = props.options, searchable = props.searchable, hideClear = props.hideClear, autoOpen = props.autoOpen, hideCancelConfirm = props.hideCancelConfirm, customViewRenderer = props.customViewRenderer, optionRenderer = props.optionRenderer, searchPromptText = props.searchPromptText;
    var placeholder = texts.placeholder, clear = texts.clear, focusedPlaceholder = texts.focusedPlaceholder, unfocusedPlaceholder = texts.unfocusedPlaceholder;
    var _a = React.useState(!!autoOpen), isFocused = _a[0], setIsFocused = _a[1];
    var _b = React.useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var _c = React.useState(value), unconfirmedValue = _c[0], setUnconfirmedValue = _c[1];
    var _d = React.useState(''), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = React.useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = React.useState(false), noResults = _f[0], setNoResults = _f[1];
    var cn = namespacedClassnames(deprecatedInlineSingleSelectKey, className, {
        focused: isFocused,
        'preserve-layout': props.preserveContentLayout
    });
    React.useEffect(function () {
        var noResultsExists = !!document.getElementsByClassName('no-results-content').length;
        setNoResults(noResultsExists);
    }, [searchTerm]);
    React.useEffect(function () {
        setUnconfirmedValue(value);
    }, [value === null || value === void 0 ? void 0 : value.value]);
    var fakeLoadOptions = function (_, cb) {
        cb(null, { options: options });
    };
    var onMouseOver = function () { return setIsHovered(true); };
    var onMouseLeave = function () { return setIsHovered(false); };
    var onFocus = function (e) {
        if (!isTextSelected(window)) {
            setIsFocused(!props.disabled);
        }
        e.stopPropagation();
    };
    var onLeaveFocus = function () {
        setIsLoading(false);
        setIsHovered(false);
        setIsFocused(false);
    };
    var handleOnChange = function (onChangeReturnValue) {
        if (isPromise(onChangeReturnValue)) {
            setIsLoading(true);
            onChangeReturnValue.then(onLeaveFocus, function () {
                onLeaveFocus();
                setUnconfirmedValue(value);
            });
        }
        else {
            onLeaveFocus();
        }
    };
    var onChangeSelected = function (selectedValue) {
        if (hideCancelConfirm) {
            handleOnChange(onChange(selectedValue));
        }
        else {
            setUnconfirmedValue(selectedValue);
        }
    };
    var onConfirm = function (e) {
        e.preventDefault();
        handleOnChange(onChange(unconfirmedValue));
    };
    var onCancel = function (e) {
        e.preventDefault();
        onLeaveFocus();
        setUnconfirmedValue(value);
        onChange(value);
    };
    var onClear = function (e) {
        e.preventDefault();
        if (hideCancelConfirm) {
            handleOnChange(onChange(null));
        }
        else {
            setUnconfirmedValue(null);
        }
    };
    var handleInputChange = function (input) {
        var onInputChange = props.onInputChange;
        if (onInputChange) {
            onInputChange(input);
        }
        setSearchTerm(input);
    };
    var valueRenderer = function (option) {
        if (props.valueRenderer) {
            var selected = props.valueRenderer(option);
            return selected;
        }
        else if (option) {
            if (typeof option.label === typeof '') {
                return (React.createElement(Text, { className: 'inline-text-value' }, option.label));
            }
            else {
                return option.label;
            }
        }
    };
    var onKeyDown = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        var isMenuOpen = !!document.getElementsByClassName('Select is-open').length;
        if (!isMenuOpen) {
            switch (e.keyCode) {
                case (keyCodes.enter):
                    onConfirm(e);
                    break;
                case (keyCodes.escape):
                    onCancel(e);
                    break;
                default:
                    return;
            }
        }
    };
    var focusedBody = function () {
        var _a;
        var focusedBodyClassName = classNames('focused-body', { checkbox: searchable === false });
        var style = (_a = {},
            _a['--maybe-hide-cursor'] = (unconfirmedValue === null || unconfirmedValue === void 0 ? void 0 : unconfirmedValue.label) && !searchTerm ? 'transparent' : 'inherit',
            _a);
        var noResultsContent = (React.createElement("div", { className: 'no-results-content' },
            React.createElement("div", { className: 'primary-text' },
                React.createElement(Text, { className: 'primary-texts' }, 'No results matching'),
                React.createElement(Text, { className: 'primary-texts', type: 'tm' }, "'" + searchTerm + "'")),
            React.createElement(Text, { type: 'ts', color: 't40' }, 'Try searching for another term')));
        var inlineControl = (React.createElement(InlineControl, { onConfirm: onConfirm, onCancel: onCancel, onClear: onClear, disabledClear: !(unconfirmedValue === null || unconfirmedValue === void 0 ? void 0 : unconfirmedValue.value), disabledConfirm: noResults, clearText: clear, hideClear: hideClear, hideCancelConfirm: hideCancelConfirm }));
        var loader = React.createElement("div", { className: 'loader-wrapper' },
            React.createElement(TinyLoader, null));
        var toggleIcon = React.createElement(Icon, { icon: smallCollapsibleToggle, className: 'toggle-icon' });
        var maybeMenuPortal = props.bringMenuToFront ? {
            menuPortalTarget: document.body
        } : {};
        return (React.createElement("div", { className: focusedBodyClassName },
            React.createElement("div", { className: 'select-container', style: style },
                React.createElement(ReactSelectAsync, __assign({}, inlineDefaultProps, props, maybeMenuPortal, { valueRenderer: valueRenderer, loadOptions: fakeLoadOptions, placeholder: focusedPlaceholder || placeholder, onChange: onChangeSelected, inputValue: searchTerm, onInputChange: handleInputChange, value: unconfirmedValue, onInputKeyDown: onKeyDown, noResultsText: noResultsContent, disabled: isLoading, filterOption: props.onSearchFilter, optionRenderer: optionRenderer, searchPromptText: searchPromptText })),
                isLoading ? loader : toggleIcon),
            isLoading || (searchTerm && !noResults) ? null : inlineControl));
    };
    var unFocusedBody = function () {
        var maybeHover = (isHovered && !props.disabled) ? React.createElement(Text, { color: 't60' }, placeholder) : React.createElement(Text, { color: 't50' }, unfocusedPlaceholder || '-');
        var unfocusedText = (React.createElement(Text, { ellipsis: true, relativeToBody: true, direction: props.disabled ? 'bottom' : 'top', className: 'unfocused-text' }, (valueRenderer(value) || maybeHover)));
        var unfocusedValue = props.valueRenderer && value ? unfocusedText : (value === null || value === void 0 ? void 0 : value.label) ?
            typeof (value === null || value === void 0 ? void 0 : value.label) === typeof placeholder ?
                unfocusedText : value === null || value === void 0 ? void 0 : value.label : maybeHover;
        var comp = (React.createElement("div", { className: classNames('unfocused-body', { disabled: !!props.disabled }) }, unfocusedValue));
        if (props.disabled) {
            return (React.createElement(Tooltip, { relativeToBody: true, body: props.disabled }, comp));
        }
        else if (customViewRenderer) {
            return React.createElement("div", { className: 'custom-view' }, customViewRenderer());
        }
        else {
            return comp;
        }
    };
    var fieldContent = props.preserveContentLayout ? (React.createElement(React.Fragment, null,
        unFocusedBody(),
        isFocused && focusedBody())) : (isFocused ? focusedBody() : unFocusedBody());
    return (React.createElement("div", { className: cn },
        React.createElement("div", { onClick: onFocus, onBlur: onConfirm, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave }, fieldContent)));
};
//# sourceMappingURL=index.js.map